import React, { Component } from "react";

class UnauthorizedApp extends Component {
  render() {
    return <h1>Unauthorized</h1>;
  }
}

export default UnauthorizedApp;
